import moment from "moment";

export default (value: string, format = "DD/MM/YYYY HH:mm") => {
  if (!value) {
    return value;
  }
  const momentDate = moment(String(value));
  return momentDate.isValid() ? momentDate.format(format) : "";
};
